import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { setAdvertisement } from "../redux/slices/interfaceSlice";
import { useGetClubInfoQuery } from "@/queries/useGetClubInfoQuery";
import { useClub } from "@/contexts/ClubContext";
import { useGetClientQuery } from "@/queries/useGetClientQuery";

export const useClubInfo = () => {
  const { selectedClubId } = useClub();
  const dispatch = useDispatch();

  const { data: clubInfoData, isLoading } = useGetClubInfoQuery(selectedClubId);
  const { data: clientData } = useGetClientQuery();

  const data = useMemo(() => {
    const content = clubInfoData?.data?.cabinet_info_content;
    if (!content) return null;

    // Remove all special characters from phone number (keep only digits)
    const clientPhone = clientData?.phone?.replace(/\D/g, "") || "";
    return content.replaceAll("#phone_number#", clientPhone);
  }, [clubInfoData, clientData]);

  const branchCode = clubInfoData?.data?.code_1c || "";
  const clientPhone = clientData?.phone?.replace(/\D/g, "") || "";

  const advertisement = useMemo(() => {
    if (clubInfoData?.data?.cabinet_posts && clubInfoData.data.cabinet_posts.length > 0) {
      return clubInfoData.data.cabinet_posts[0];
    }
    return null;
  }, [clubInfoData]);

  useEffect(() => {
    dispatch(setAdvertisement(advertisement));
  }, [advertisement, dispatch]);

  return { data, isLoading, branchCode, clientPhone };
};
